import {
  Box,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import Intercom from "@intercom/messenger-js-sdk";

import {
  CalendarToday as CalendarIcon,
  CardMembership as CardMembershipIcon,
  BarChart as BarChartIcon,
  CreditCard as CreditIcon,
  ExpandLess,
  ExpandMore,
  FormatListBulleted as ListIcon,
  Key as KeyIcon,
  Logout as LogoutIcon,
  MailOutline,
  MoreVert as MoreIcon,
  Settings as SettingsIcon,
  PeopleAltOutlined,
} from "@mui/icons-material";
import ReserveIcon from "@assets/svg/reserve.svg?react";
import AppMarketIcon from "@assets/svg/AppMarket.svg?react";
import ChannelsIcon from "@assets/svg/ConnectNewChannel.svg?react";

import useBreakPoinst from "@hooks/useBreakPoinst";
import Trail from "@assets/svg/trailInfo.svg?react";
import CloseIcon from "@assets/svg/close-cross.svg?react";
import BlackCloseIcon from "@assets/svg/close-cross-black.svg?react";
import BlackInfo from "@assets/svg/blackInfo.svg?react";
import Rocket1 from "@assets/svg/Rocket1.svg?react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import LanguageIcon from "@mui/icons-material/Language";
import { VerificationHeaderAlert } from "@components/PermitVerification/VerificationHeaderAlert";
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  SupscriptionModal as SupscriptionPlaneModal,
  SubscriptModal,
  ThreeDaysToSupscripeModal,
} from "@components";

import {
  Outlet,
  useLocation,
  useNavigate,
  createSearchParams,
} from "react-router-dom";
import { FC, ReactNode, Suspense, useEffect, useMemo, useState, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "../../utils/image-consts";
import { useAuth, useGetUserDetail } from "@services";
import { disabledFeatures } from "@utils";
import { useRecoilState, useSetRecoilState } from "recoil";
import { userDetailsStore } from "@store/userDetail";
import { subscriptionPlanNameStore } from "@store/subscriptionPlanName";

import { UserHasPermission } from "@hooks/user-has-permission";
import BannerSection from "../../pages/ManagePlan/banner";
import RemainingDaysPopUp from "../../pages/ManagePlan/popUp/index";
import { usePermissions } from "@hooks/usePermissions";
import { useIsFreemium } from "@hooks/useIsFreemium";
import StartModal from "../../pages/OnBoardingJourny/components/Airbnb/StartModal";
import { useOnboarding } from "../../services/useOnboarding";
import {
  LayoutContainer,
  MainContent,
  ContentArea,
  StyledToolbar,
  ToolbarContent,
  TrialBanner,
  TrialContent,
  TrialText,
  TrialDaysText,
  TrialActions,
  ActivateButton,
  CloseButton,
  DrawerContainer,
  LogoContainer,
  MenuBottomSection,
  MenuItemButton,
  ChildMenuItemButton,
  LogoutButton,
  CollapseContainer,
  MenuSection,
  TemporaryDrawer,
  PermanentDrawer,
  StyledNavLink,
  MobileMenuButton,
  AppMarketIconWrapper,
} from "./styles";

const Layout = () => {
  const {
    showAccounting,
    showAppMarketplace,
    showAutomation,
    showCalendar,
    showDashboard,
    showGuestManagement,
    showControlCenter,
    showInbox,
    showLockManagement,
    showMessagManagement,
    showListingManagement,
    showOwnerManagement,
    showReservations,
    showSettings,
    showSubscriptionManagement,
    showTaskManagement,
    showTeamManagement,
    showYourWebsite,
  } = usePermissions();

  const { data: getUserDetail } = useGetUserDetail();
  const subscriptionRemainingDays =
    getUserDetail?.result?.popUpMessage?.subscriptionRemainingDays ?? 0;
  const [userDetailsState, setUserDetailsState] =
    useRecoilState(userDetailsStore);
  const setsubscriptionPlanNameState = useSetRecoilState(
    subscriptionPlanNameStore
  );
  const { pathname } = useLocation();
  const [showSupscriptionModal, setShowSupscriptionModal] = useState(false);
  const [showSubscibeModal, setShowSubscibeModal] = useState(false);
  const [showTrialTip, setShowTrialTip] = useState(false);
  const [showThreeDaysModal, setShowThreeDaysModal] = useState(false);
  const [showStartModal, setShowStartModal] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);

  const { isPhone } = useBreakPoinst();
  const isFreemium = useIsFreemium();

  const { logout } = useAuth();
  const active = useMemo(() => pathname?.split("/")[1], [pathname]);
  const subActive = useMemo(() => pathname?.split("/")[2], [pathname]);
  const {
    i18n: { language, changeLanguage },
    t,
  } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [menuOpen, setMenuOpen] = useState<string | undefined>(active);
  const navigate = useNavigate();
  const { getUserInfo } = useAuth();
  const { getCheckOnboardingQuery } = useOnboarding();
  const { data: checkOnboardingObj } = getCheckOnboardingQuery();

  // Check if user has OwnerPortal permission - block them from dashboard
  const rawPermissions = localStorage.getItem("rolePermissions");
  const permissions = rawPermissions ? JSON.parse(rawPermissions) : [];
  const hasOwnerPortalPermission = permissions.some((p: any) => p.permissionName === "OwnerPortal");
  
  // Redirect owners to their portal immediately
  useEffect(() => {
    if (hasOwnerPortalPermission) {
      navigate("/owner-portal", { replace: true });
    }
  }, [hasOwnerPortalPermission, navigate]);

  // Don't render layout for owners
  if (hasOwnerPortalPermission) {
    return null;
  }

  const user = getUserInfo();
  const isThereeDaysOrLessLeft =
    userDetailsState?.result?.trialDays <= 3 &&
    userDetailsState?.result?.trialDays > 0;
  const showToolbar = useMemo(
    () => pathname !== "/website-builder",
    [pathname]
  );
  const backgroundColor = useMemo(() => {
    let code = "";
    if (pathname !== "/website-builder") {
      code = "#f6f6f8";
    } else {
      let onWebsiteBuilderContent =
        localStorage.getItem("@website_builder_completed_onboarding") == "true";
      if (onWebsiteBuilderContent) {
        code = "#f6f6f8";
      } else {
        code = "white";
      }
    }
    return subscriptionRemainingDays <= 0 ? "white" : code;
  }, [pathname, localStorage]);
  useEffect(() => {
    try {
      Intercom({
        app_id: "gxvh8q6n",
        user_id: user?.id,
        name: user?.fullName,
        email: user?.email,
        created_at: user?.createDate,
        alignment: language === "en" ? "right" : "left"
      });
    } catch (error) {
      // Silently fail if Intercom fails to initialize (e.g., blocked by firewall/extension)
      console.warn("Intercom initialization failed:", error);
    }
  }, []);
  useEffect(() => {
    setShowOnboarding(
      checkOnboardingObj?.result?.isOnboardingComplete ? false : true
    );
  }, [checkOnboardingObj]);

  useEffect(() => {
    if (userDetailsState?.result?.trialDays == null) return;
    if (isThereeDaysOrLessLeft) {
      setShowThreeDaysModal(true);
    } else {
      setShowThreeDaysModal(false);
    }
  }, [isThereeDaysOrLessLeft, userDetailsState]);

  useEffect(() => {
    // Freemium users are on the auto-created trial underneath (step 1 mock);
    // they get the freemium banner instead of trial/subscribe prompts.
    if (isFreemium) {
      setShowTrialTip(false);
      setShowSubscibeModal(false);
      setShowThreeDaysModal(false);
      return;
    }
    if (
      userDetailsState?.result?.trialDays == null &&
      !userDetailsState?.result?.hasActiveSubscription
    )
      return;
    if (userDetailsState?.result?.trialDays > 0) {
      return setShowTrialTip(true);
    } else {
      setShowTrialTip(false);
    }
    if (
      !userDetailsState?.result?.hasActiveSubscription &&
      userDetailsState?.result?.isNewUser
    ) {
      setShowSubscibeModal(true);
    } else {
      setShowSubscibeModal(false);
    }
  }, [userDetailsState, setShowSubscibeModal, setShowTrialTip]);

  useEffect(() => {
    if (getUserDetail) {
      setUserDetailsState(getUserDetail);
      setsubscriptionPlanNameState(getUserDetail.result.subscriptionPlanName);
    }
  }, [getUserDetail, setUserDetailsState, setsubscriptionPlanNameState]);

  useEffect(() => {
    // StartModal upsells the OTA connect journey (/chooseChannel) — never for Freemium.
    if (isFreemium) return;
    const timer = setTimeout(() => {
      checkOnboardingObj?.result?.isOnboardingComplete == false &&
        setShowStartModal(true);
    }, 1500);

    return () => clearTimeout(timer); // Clean up on unmount
  }, [isFreemium]);

  interface MenuItemsProps {
    to: string;
    open?: boolean;
    title: string;
    linkActive?: string;
    child?: boolean;
    clickableCollapse?: boolean;
    startIcon?: ReactNode;
  }

  const RenderTrail = memo(() => {
    // Upgrade-plan banner (الخطة المجانية + ترقّ الآن) is pulled for this version —
    // the paid upgrade flow isn't offered yet. Restore this block to bring it back.
    if (isFreemium) {
      return null;
    }
    if (!showTrialTip) return null;
    return (
      <TrialBanner isThreeDaysOrLess={isThereeDaysOrLessLeft}>
        <TrialContent>
          {isThereeDaysOrLessLeft ? <BlackInfo /> : <Trail />}
          <TrialText isThreeDaysOrLess={isThereeDaysOrLessLeft} isPhone={isPhone}>
            {t("trial.YOU_ARE_IN_TRIAL")}
            <TrialDaysText isThreeDaysOrLess={isThereeDaysOrLessLeft}>
              {" "}
              {`${userDetailsState?.result?.trialDays}  ${t("trial.DAYS")}`}
            </TrialDaysText>
            {t("trial.TO_END")}
          </TrialText>
        </TrialContent>
        <TrialActions>
          <ActivateButton
            language={language}
            onClick={() =>
              true ? navigate("/subscribe") : setShowSupscriptionModal(true)
            }
          >
            {t("trial.ACTIVATE_NOW")}
          </ActivateButton>
          <CloseButton onClick={() => setShowTrialTip(false)}>
            {isThereeDaysOrLessLeft ? <BlackCloseIcon /> : <CloseIcon />}
          </CloseButton>
        </TrialActions>
      </TrialBanner>
    );
  });
  const breadcrumbNameMap: { [key: string]: string } = {
    "/dashboard/listing": "Listing",
    "/inbox/important": "Important",
    "/trash": "Trash",
    "/spam": "Spam",
    "/drafts": "Drafts",
  };

  const variantLink = (link?: string): "text" | "contained" =>
    link === active ? "contained" : "text";
  const childVariantLink = (link?: string): "primary" | "inherit" =>
    link === subActive ? "primary" : "inherit";

  const MenuItemsLink: FC<MenuItemsProps> = memo(({
    to,
    open,
    title,
    child,
    linkActive,
    startIcon,
    clickableCollapse = false,
  }) => {
    const handleMenuClick = useCallback(() => {
      setMenuOpen(to === menuOpen ? undefined : to);
      if (clickableCollapse) {
        navigate(`/${to}`);
      }
    }, [to, menuOpen, clickableCollapse, navigate]);

    let Wrapper = ({ children }: { children: ReactNode }) => (
      <StyledNavLink
        to={to}
        isSettings={linkActive === "settings"}
      >
        {children}
      </StyledNavLink>
    );
    
    let expandIcon = null;
    if (open != null) {
      expandIcon = open ? <ExpandLess /> : <ExpandMore />;
      Wrapper = ({ children }) => (
        <Box onClick={handleMenuClick}>
          {children}
        </Box>
      );
    }
    
    const ButtonComponent = child ? ChildMenuItemButton : MenuItemButton;
    
    return (
      <Wrapper>
        <ButtonComponent
          startIcon={startIcon}
          endIcon={expandIcon}
          fullWidth
          variant={variantLink(linkActive)}
          color={child ? childVariantLink(linkActive) : "primary"}
        >
          {title}
        </ButtonComponent>
      </Wrapper>
    );
  });

  const ChangeLang = memo(() => {
    const handleLanguageChange = useCallback(() => {
      changeLanguage(language === "en" ? "ar" : "en");
    }, [language, changeLanguage]);

    return (
      <IconButton size="large" onClick={handleLanguageChange}>
        <Typography color={"primary"} width={24} height={24}>
          {language === "en" ? "ع" : "En"}
        </Typography>
      </IconButton>
    );
  });
  const RenderDrawer = memo(() => {
    const { isPhone } = useBreakPoinst();

    return (
      <DrawerContainer>
          <LogoContainer
            src={Logo}
            alt="Logo"
          />
        <PerfectScrollbar >
          <div className="mx-4">
            {/* OTA onboarding journey (connect Airbnb/Booking/Gathern) — never for Freemium */}
            {!isFreemium && showOnboarding && (
              <MenuItemsLink
                to="/chooseChannel"
                linkActive={"chooseChannel"}
                title={t("ChooseChannel.Title")}
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="20"
                    height="20"
                    fill={active === "chooseChannel" ? "white" : "#5B3FFF"}
                  >
                    <path d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
                  </svg>
                }
              />
            )}

            {!disabledFeatures.dashboard && (showDashboard || showYourWebsite) && (
              <MenuItemsLink
                to="/dashboard"
                startIcon={<BarChartIcon />}
                linkActive={"dashboard"}
                title={t("DASHBOARD.TITLE")}
              />
            )}
            {showCalendar && (
              <MenuItemsLink
                to="/calendar"
                startIcon={<CalendarIcon />}
                linkActive={"calendar"}
                title={t("DASHBOARD.CALENDAR")}
              />
            )}
            {/* ----------------------------------- DM ----------------------------------- */}
            {!disabledFeatures.dm && showInbox && (
              <MenuItemsLink
                to="/direct-messages"
                startIcon={<MailOutline />}
                linkActive={"direct-messages"}
                title={t("DM.MESSAGES")}
              />
            )}
            {/* ----------------------------------- DM ----------------------------------- */}
            {showListingManagement ? (
              <MenuSection>
                <MenuItemsLink
                  to="properties-management"
                  startIcon={<ListIcon />}
                  // Expandable only when it has children (Categories, hidden for
                  // Freemium). For Freemium it's a plain link — no empty chevron.
                  open={isFreemium ? undefined : menuOpen === "properties-management"}
                  linkActive={"properties-management"}
                  title={t("PROPERTIES_MANAGEMENT.TITLE")}
                  clickableCollapse={!isFreemium}
                />
                {!isFreemium && (
                  <Collapse
                    in={menuOpen === "properties-management"}
                    timeout="auto"
                    unmountOnExit
                  >
                    <CollapseContainer>
                      {/* Categories management — hidden for Freemium */}
                      <MenuItemsLink
                        to="/category-management"
                        linkActive={"category-management"}
                        title={t("CATEGORYMANAGER.TITLE")}
                        child
                      />
                    </CollapseContainer>
                  </Collapse>
                )}
              </MenuSection>
            ) : null}
            {showLockManagement && (
              <MenuSection>
                <MenuItemsLink
                  to="locks-management/control"
                  open={menuOpen === "locks-management/control"}
                  linkActive={"locks-management"}
                  startIcon={<KeyIcon />}
                  title={t("LOCKS.TITLE")}
                  clickableCollapse
                />
                <Collapse
                  in={menuOpen === "locks-management/control"}
                  timeout="auto"
                  unmountOnExit
                >
                  <CollapseContainer>
                    {showListingManagement && (
                      <MenuItemsLink
                        linkActive={"listing"}
                        title={t("DASHBOARD.LIST")}
                        to="/locks-management/listing"
                        child
                      />
                    )}
                  </CollapseContainer>
                </Collapse>
              </MenuSection>
            )}
            {showAccounting && (
              <MenuItemsLink
                to="finance/accounting"
                startIcon={<CreditIcon />}
                open={menuOpen === "finance"}
                title={t("FINANCE.TITLE")}
                linkActive={"finance"}
                clickableCollapse
              />
            )}
            {(showMessagManagement || showYourWebsite) && (
              <MenuItemsLink
                to="/messaging"
                startIcon={<MailOutline />}
                linkActive={"messaging"}
                title={t("MESSAGING.TITLE")}
              />
            )}
            {showOwnerManagement && (
              <MenuItemsLink
                to="/owner-management"
                startIcon={<PeopleAltOutlined />}
                linkActive={"owner-management"}
                title={t("OwnerManagement.Title")}
              />
            )}
            {showSubscriptionManagement && (
              <MenuItemsLink
                to="/manage-plan"
                startIcon={<CardMembershipIcon />}
                linkActive={"manage-plan"}
                title={t("MANAGE_PLAN.TITLE")}
              />
            )}
            {showReservations && (
              <MenuItemsLink
                to="/reservation-management"
                startIcon={<ReserveIcon />}
                linkActive={"reservation-management"}
                title={t("RESERVATIONLIST")}
              />
            )}
            {showGuestManagement && (
              <MenuItemsLink
                to="/guest-management"
                startIcon={<ReserveIcon />}
                linkActive={"guest-management"}
                title={t("GUESTMANAGEMENT")}
              />
            )}
            {/* ----------------------- */}
            {showAutomation && (
              <MenuItemsLink
                to="/automation"
                startIcon={<BarChartIcon />}
                linkActive={"automation"}
                title={t("Automation.AutomationHeader")}
              />
            )}
            {/* ----------------------- */}
            {showTeamManagement && (
              <MenuItemsLink
                to="/user-management"
                startIcon={<BarChartIcon />}
                linkActive={"user-management"}
                title={t("UserManagement.UserManagement")}
              />
            )}
            {/* app Market  */}
            {showAppMarketplace && (
              <MenuItemsLink
                to="/apps"
                startIcon={
                    <AppMarketIcon  fill= '#5B3FFF'/>
                  }
                linkActive={"apps"}
                title={t("AppMarket.Title")}
              />
            )}
            {/* Channels — hidden for Freemium (OTA feature) */}
            {!isFreemium && (
            <MenuSection>
              <MenuItemsLink
                to="channels"
                startIcon={<ChannelsIcon />}
                // open={menuOpen === "channels"}
                linkActive={"channels"}
                title={t("CHANNELS.PAGE_TITLE")}
                // clickableCollapse
              />
              {/* <Collapse
                in={menuOpen === "channels"}
                timeout="auto"
                unmountOnExit
              >
                <CollapseContainer>
                  <MenuItemsLink
                    to="/channels/units-mapping"
                    linkActive={"units-mapping"}
                    title={t("CHANNELS.UNITS_MAPPING.TITLE")}
                    child
                  />
                </CollapseContainer>
              </Collapse> */}
            </MenuSection>
            )}
            {/* ---------------------------- */}
            <MenuBottomSection isPhone={isPhone}>
              {showTaskManagement && (
                  <MenuItemsLink
                    to="/task-management"
                    linkActive={"task-management"}
                    startIcon={<TaskAltIcon />}
                    title={t("TaskManagemnt.title")}
                  />
                )}
              {/* localStorage.getItem("showWebsiteBuilder") == "true" && */}
              
              {showYourWebsite ? (
                <MenuItemsLink
                  to="/website-builder"
                  linkActive={"website-builder"}
                  startIcon={<LanguageIcon />}
                  title={t("WebsiteBuilder.Special_Site")}
                />
              ) : null}
              {showSettings && (
                <MenuItemsLink
                  to="/settings"
                  linkActive={"settings"}
                  startIcon={<SettingsIcon />}
                  title={t("SETTINGS")}
                />
              )}
              <LogoutButton
                onClick={logout}
                variant={"text"}
                color={"error"}
                startIcon={<LogoutIcon />}
              >
                {t("SIGN_OUT")}
              </LogoutButton>
            </MenuBottomSection>
          </div>
        </PerfectScrollbar>
      </DrawerContainer>
    );
  });

  return (
    <LayoutContainer>
      <TemporaryDrawer
        variant="temporary"
        open={mobileOpen}
        anchor={language === "ar" ? "right" : "left"}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <RenderDrawer />
      </TemporaryDrawer>
      <PermanentDrawer
        variant="permanent"
        anchor={language === "ar" ? "right" : "left"}
        open
      >
        <RenderDrawer />
      </PermanentDrawer>
      <MainContent
        component="main"
        backgroundColor={backgroundColor}
      >
        <RenderTrail />
        {showToolbar ? (
          <StyledToolbar>
            <ToolbarContent>
              {/* MT permit nudge — pushes to the inline-start, switcher stays at end */}
              <Box sx={{ marginInlineEnd: "auto", minWidth: 0, display: "flex" }}>
                <VerificationHeaderAlert />
              </Box>
              <ChangeLang />
              <MobileMenuButton
                onClick={() => setMobileOpen(true)}
                size="large"
              >
                <MoreIcon />
              </MobileMenuButton>
            </ToolbarContent>
          </StyledToolbar>
        ) : null}

        <ContentArea>
          <Suspense fallback={<></>}>
            {userDetailsState?.result?.popUpMessage?.isDisplay && (
              <BannerSection />
            )}
            <Outlet />
          </Suspense>
        </ContentArea>
      </MainContent>
      <SubscriptModal
        open={showSubscibeModal}
        setShowSupscriptionModal={setShowSupscriptionModal}
      />
      <RemainingDaysPopUp />
      {!isFreemium && showStartModal && <StartModal />}
      <SupscriptionPlaneModal
        OnSubscriptionSelected={(pack: number) => {
          setShowSupscriptionModal(false);
          navigate({
            pathname: "/register",
            search: createSearchParams({
              package: pack.toString(),
              id: window.localStorage.getItem("userId") ?? "",
            }).toString(),
          });
        }}
        open={showSupscriptionModal}
        handleClose={() => setShowSupscriptionModal(false)}
      />
      <ThreeDaysToSupscripeModal
        onSupscribe={() => {
          setShowThreeDaysModal(false);
          //setShowSupscriptionModal(true)
          navigate("/subscribe");
        }}
        open={showThreeDaysModal}
        handleClose={() => setShowThreeDaysModal(false)}
      />
    </LayoutContainer>
  );
};

export default Layout;
